export class Options {
    constructor(
      public text: string,
      public value: string,
      public active?: boolean) { }
  }
  